/* globals tdconv */

export function initTradeDoublerTrackingLibrary(consents) {
  (function (i, s, o, g, r, a, m) {
    i["TDConversionObject"] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "https://svht.tradedoubler.com/tr_sdk.js?org=2277946",
    "tdconv"
  );

  tdconv("cookie-consent", consents.advertising);
  tdconv("tracking-consent", consents.advertising);
}
